import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, FormInput, FormButton, Button } from '../../../Common';
import { ForgotPasswordData, forgotPasswordSchema, forgotPasswordDefaultValues } from './ForgotPasswordForm.helper';
import './ForgotPasswordForm.css';

type ForgotPasswordFormProps = {
  onSubmit?: (data: ForgotPasswordData) => Promise<void> | void;
  onBackToSignIn?: () => void;
  className?: string;
};

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onSubmit,
  onBackToSignIn,
  className = '',
}) => {
  const handleSubmit = async (data: ForgotPasswordData) => {
    try {
      await onSubmit?.(data);
    } catch (error) {
      console.error('Forgot password failed:', error);
      throw error;
    }
  };

  return (
    <div className={`forgot-password-container ${className}`}>
      <div className="forgot-password-title-section">
        <h1 className="forgot-password-title">Forgot Password</h1>
        <p className="forgot-password-subtitle">
          Please enter your email address to restore your password
        </p>
      </div>

      <Form
        onSubmit={handleSubmit}
        className="forgot-password-form-fields"
        defaultValues={forgotPasswordDefaultValues}
        resolver={yupResolver(forgotPasswordSchema)}
      >
        <FormInput
          name="email"
          placeholder="Email address"
          type="email"
          required
          fullWidth
        />

        <FormButton type="submit" primary size="full">
          Restore password
        </FormButton>
      </Form>

      <Button
        type="button"
        onClick={onBackToSignIn}
        primary={false}
        bordered={false}
        size="full"
      >
        Back to Sign In
      </Button>
    </div>
  );
};

export default ForgotPasswordForm;
